import React, { useEffect, useRef, useState } from 'react';
import portfolioAPI from '../services/portfolioAPI';
import './Hero.css';

const Hero = () => {
  const particlesRef = useRef();
  const [personalInfo, setPersonalInfo] = useState(null);
  const [currentRole, setCurrentRole] = useState(0);
  const [displayText, setDisplayText] = useState('');
  const [isTyping, setIsTyping] = useState(true);
  const profileImageSrc = `${process.env.PUBLIC_URL}/images/Formal.png?v=20260710`;
  
  const roles = [
    "Fullstack Developer",
    "AI Engineer", 
    "ML Engineer",
    "Cloud Developer"
  ];
  
  useEffect(() => {
    const fetchPersonalInfo = async () => {
      try {
        const info = await portfolioAPI.getPersonalInfo();
        setPersonalInfo(info);
      } catch (error) {
        console.error('Error fetching personal info:', error);
      }
    };

    fetchPersonalInfo();
  }, []);

  useEffect(() => {
    // Track page visit
    // React StrictMode mounts components twice in development.
    // Use a per-page-load guard on window so each reload tracks exactly once.
    if (!window.__portfolioVisitTracked) {
      window.__portfolioVisitTracked = true;
      portfolioAPI.trackVisit('/');
    }
  }, []);

  useEffect(() => {
    const createParticles = () => {
      const container = particlesRef.current;
      if (!container) return;

      for (let i = 0; i < 50; i++) {
        const particle = document.createElement('div');
        particle.className = 'particle';
        particle.style.left = Math.random() * 100 + '%';
        particle.style.animationDelay = Math.random() * 20 + 's';
        particle.style.animationDuration = (Math.random() * 3 + 2) + 's';
        container.appendChild(particle);
      }
    };

    createParticles();
  }, []);

  // Typing animation effect
  useEffect(() => {
    const currentRoleText = roles[currentRole];
    let timeout;

    if (isTyping) {
      if (displayText.length < currentRoleText.length) {
        timeout = setTimeout(() => {
          setDisplayText(currentRoleText.slice(0, displayText.length + 1));
        }, 100);
      } else {
        timeout = setTimeout(() => {
          setIsTyping(false);
        }, 2000);
      }
    } else {
      if (displayText.length > 0) {
        timeout = setTimeout(() => {
          setDisplayText(displayText.slice(0, -1));
        }, 50);
      } else {
        setCurrentRole((prev) => (prev + 1) % roles.length);
        setIsTyping(true);
      }
    }

    return () => clearTimeout(timeout);
  }, [displayText, currentRole, isTyping, roles]);

  if (!personalInfo) {
    return <div>Loading...</div>;
  }

  const nameParts = personalInfo.name.split(' ');

  return (
    <section id="hero" className="hero-section">
      <div className="particles-container" ref={particlesRef}></div>
      <div className="hero-content">
        <div className="hero-text">
          <div className="hero-name-section">
            <div className="profile-photo">
              <img 
                src={profileImageSrc} 
                alt="Profile" 
                className="profile-image"
              />
            </div>
            <div className="name-container">
              <h1 className="hero-name">
                {nameParts.map((part, index) => (
                  <span key={index} className="name-part">{part}</span>
                ))}
              </h1>
            </div>
          </div>
          <p className="hero-description">
            {"Passionate B.Tech Engineer specializing in full-stack development, creating innovative solutions with modern web technologies."}
          </p>
          <div className="hero-buttons">
            <button className="cta-button primary" onClick={() => document.getElementById('projects').scrollIntoView({ behavior: 'smooth' })}>
              View Projects
            </button>
            <button className="cta-button secondary" onClick={() => document.getElementById('contact').scrollIntoView({ behavior: 'smooth' })}>
              Get In Touch
            </button>
          </div>
        </div>
        <div className="hero-visual">
          <div className="laptop-container">
            <div className="laptop">
              <div className="laptop-screen">
                <div className="screen-content">
                  <div className="greeting-text">Hi I am a</div>
                  <div className="typing-text">
                    {displayText}
                    <span className="cursor">|</span>
                  </div>
                </div>
              </div>
              <div className="laptop-base"></div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;